import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { ResourceSet } from 'libs/abc/core/resources/src/lib/resource-set';
import { FeatureGeometryType } from '../../models/element.model';

export enum FeatureSelectionMode {
  Digitizing = 0,
  Selecting = 1,
}

@Component({
    selector: 'abc-graphics-feature-selector',
    templateUrl: './feature-selector.component.html',
    styleUrls: ['./feature-selector.component.scss'],
    standalone: false
})
export class FeatureSelectorComponent implements AfterViewInit, OnInit {
  @ViewChild('selectorContainer', { static: false })
  selectorContainer: ElementRef;
  @Output() featureSelectionClosed = new EventEmitter();
  @Output() cancelfeatureSelection = new EventEmitter();
  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;
  public isGeometryValid: boolean = false;
  private featureGeometryType: FeatureGeometryType = FeatureGeometryType.Polygon;
  private selectionMode: FeatureSelectionMode = FeatureSelectionMode.Digitizing;

  constructor(private resourceService: ResourceManagerService) {
    this.resAsync = this.resourceService.getResourceSet('abc-graphics-adapters-open-layers');
  }

  async ngOnInit() {
    this.res = await this.resAsync;
  }

  ngAfterViewInit() {
    this.setVisible(false);
  }

  public setFeatureGeometryType(geometryType: FeatureGeometryType): void {
    this.featureGeometryType = geometryType;
  }

  public setFeatureSelectionMode(mode: FeatureSelectionMode): void {
    this.selectionMode = mode;
  }

  public getFeatureSelectionMode(): FeatureSelectionMode {
    return this.selectionMode;
  }

  public setVisible(visible: boolean): void {
    if (this.selectorContainer && this.selectorContainer.nativeElement)
      this.selectorContainer.nativeElement.style.display = visible ? 'block' : 'none';
  }

  public close() {
    if (this.isGeometryValid) {
      this.setVisible(false);
      this.featureSelectionClosed.emit();
    }
  }
  public cancel() {
    this.setVisible(false);
    this.cancelfeatureSelection.emit();
  }

  public getHelpText() {
    if (this.selectionMode === FeatureSelectionMode.Digitizing) {
      return this.res.get('Controls-FeatureSelector-HelpText', this.getCurrentFeatureGeometryTypeName());
    } else {
      return 'Objekte markieren/selektieren...'; //localization
    }
  }
  public getCurrentFeatureGeometryTypeName(): string {
    if (this.featureGeometryType === FeatureGeometryType.Point) {
      return this.res.get('Controls-FeatureSelector-Point');
    } else if (this.featureGeometryType === FeatureGeometryType.Line) {
      return this.res.get('Controls-FeatureSelector-Polyline');
    } else {
      return this.res.get('Controls-FeatureSelector-Polygon');
    }
  }
}
